import { AxiosResponse } from 'axios';
import {
  NotificationAnscOperator,
  NotificationAnsc,
} from 'civil-status/model/notification-ansc-operator';
import { NotificationsListAnscOperator } from 'civil-status/view-models/notifications-list-ansc-operator';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';

export const transformNotificationsListAnscOperator = (
  response: AxiosResponse<HttpResponse<NotificationAnscOperator>>
): Array<NotificationsListAnscOperator> => {
  const dataRes = response.data.payload.notifiche || [];
  const datiPaginazione = response.data.payload.datiPaginazione || {};

  return dataRes.map((item) => ({
    currentItem: item as NotificationAnsc,
    totalCount: datiPaginazione.numRecordTotali || 0,
    ambito: item.ambito || '',
    idNotificationKind: item.genereNotifiche || '',
    destinationAct: item.attoDestinazione || '',
    municipalityDestination: item.comuneDestinatario || '',
    register: item.registroDestinazione || '',
    formationDate: item.dataInizioValidita
      ? DateTime.fromISO(item.dataInizioValidita).toFormat('dd/MM/yyyy HH:mm')
      : '',
    municipalityFormation: item.nomecomuneform || '',
    operator: item.cognomeNomeOperatore || '',
    sourceEvent: item.ideventosorgente?.toString() || '',
    state: item.idStatoFlussoNotifiche || '',
    description: item.descrizione || '',
    holders: item.descsoggettointestatario || '',
    idAnsc: item.idAnsc || '',
    idNotifica: item.idNotifica || '',
    idGenereNotifiche: item.idGenereNotifiche || '',
  }));
};
